<script setup>
import * as heroIcons from '@heroicons/vue/24/solid';
import {defineProps, ref, onMounted, computed} from 'vue'
import IconOutline from '@/Shared/Icons/IconOutline.vue'
import IconSolid from '@/Shared/Icons/IconSolid.vue'
import IconMini from '@/Shared/Icons/IconMini.vue'
import CustomIcons from '@/Shared/CustomIcons.vue'

const props = defineProps({
  name: String,
  mini: Boolean,
  solid: Boolean,
  outline: Boolean,
  customIcon: {
    type: Boolean,
    default: false,
  },
})

const isLoaded = ref(false)
const icons = ref(heroIcons)

onMounted(() => {
  isLoaded.value = true
})

const formatedName = computed(() => {
  let name = props.name
  let final = ''
  if (name) {
    if (name.includes('-')) {
      name = name.split('-')
      name.map((text) => {
        final = final + text.charAt(0).toUpperCase() + text.slice(1)
      })
    } else {
      final = name.charAt(0).toUpperCase() + name.slice(1)
    }
  }
  return final + 'Icon'
})

</script>

<template>
  <CustomIcons v-if="customIcon" :name="name" />
  <IconOutline v-else-if="outline" :name="formatedName" />
  <IconMini v-else-if="mini" :name="formatedName" />
  <IconSolid v-else :name="formatedName" />
</template>
